import React, { useEffect, useRef, useState } from 'react'
import PageTitle from '../../../components/partials/PageTitle'
import Select from "./../../../components/form/select/Select";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
// import { getAppliedPolicies } from '../../../redux/slice/policy/policySlice';
import { exportXlsxData, sortUsersByOffice } from "../../../utils/helpers/functions";
import { getActions, getUserActivities, resetReport } from '../../../redux/slice/report/reportSlice';
import PaginationLinks from '../../../components/pagination/PaginationLinks';
import { CSVLink } from 'react-csv';
import excel from "../../../assets/images/img-icons/excel.png";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { useReactToPrint } from 'react-to-print';
import { BounceLoader } from "react-spinners";
import ModalContainer from '../../../components/modals/ModalContainer';
import AuditProperties from './AuditProperties';

const AuditReport = () => {

    const [properties, setProperties] = useState()
    const {actions, userActivity, isLoading} = useSelector((state) => state.report);
    const { user } = useSelector((state) => state?.auth?.user);

    const [sortedUsers, setSortedUsers] = useState([]);
    const [filteredItem, setFilteredItem] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [currentUserActivities, setCurrentUserActivities] = useState(userActivity?.data);

    // const { user } = useSelector((state) => state?.auth?.user);
    const { unpaginated_users } = useSelector((state) => state?.user);
    const {offices: { offices },} = useSelector((state) => state.office);

    const agentCusRef = useRef();
    const actionCusRef = useRef();
    const appliedPoliciesRef = useRef();
    const CCPdfRef = useRef();

    const dispatch = useDispatch();

    // breadcrumb
    const breadcrumb = {
        from: {
        title: "Reports",
        link: "/admin/reports",
        },
        current: {
        title: "Audit Report",
        link: null,
        },
    };

    const {
        errors,
        values,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setFieldError,
        resetForm,
      } = useFormik({
        // enableReinitialize: true,
        initialValues: {
          office_id: user?.office_id,
          staff_id: "",
          action: "",
          start_date: "",
          end_date: "",
        },
        validationSchema: () =>
          yup.object().shape({
            start_date: yup.string().required("Start Date is required"),
            end_date: yup.string().required("End Date is required"),
          }),
        onSubmit: (values) => {
          if (values?.staff_id === undefined) {
            values["staff_id"] = "";
          }
          dispatch(getUserActivities(values));
          setFilteredItem(true)
          // setFiltered("");
        },
    });

    const clearFilteredItems = () => {
        appliedPoliciesRef?.current?.clearValue();
        actionCusRef?.current?.clearValue();
        resetForm();
        setFilteredItem(false);
        dispatch(resetReport())
    };

    const fetchActivityHandler = async (pageNum) => {
        setPageNumber(pageNum);
        const payload = {
            office_id: values?.office_id,
            staff_id: values?.staff_id,
            action: values?.action,
            start_date: values?.start_date,
            end_date: values?.end_date, 
            pageNumber: pageNum
        }
        dispatch(getUserActivities(payload));
    };

    // print table to pdf
    const generatePDF = useReactToPrint({
        content: () => CCPdfRef.current,
        documentTitle: "User Activities",
    });

    useEffect(() => {
        agentCusRef?.current?.clearValue();
        if (values?.office_id) {
          let sortedUsers = sortUsersByOffice(values?.office_id, unpaginated_users);
          setSortedUsers(sortedUsers);
        } else {
          setSortedUsers([]);
        }
      }, [values?.office_id, unpaginated_users]);

    // useEffect(() => {
    //   dispatch(getActions())
    // }, [dispatch])
    
    useEffect(() => {
        if (userActivity) {
            setCurrentUserActivities(userActivity.data)
        }
    }, [userActivity])

  return (
    <>
        {/* page title */}
        <PageTitle title='Audit Report' breadcrumb={breadcrumb} />
        {/* end page title */}
        <div className="row card p-1">
            <div className='row mb-3'>
                <form className='col-md-10' onSubmit={handleSubmit}>
                    <div className='row mt-4'>
                        <div className='col-lg-2 col-md-3 text-end sm-text-end'>
                            <label htmlFor='account_type' className={`form-label mt-1`}>
                            Office
                            </label>
                        </div>
                        <div className='col-sm-6'>
                            <Select
                                onBlur={() => {
                                    handleBlur({ target: { name: "office_id" } });
                                }}
                                name='office_id'
                                data={offices?.map((item, i) => ({
                                    label: item?.office_name,
                                    value: item?.id,
                                }))}
                                value={parseInt(values?.office_id)}
                                onChange={(selectedOption) => {
                                    setFieldValue("office_id", selectedOption?.value);
                                }}
                                ref={appliedPoliciesRef}
                            />
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-lg-2 col-md-3 text-end sm-text-end'>
                            <label htmlFor='account_type' className={`form-label mt-1`}>
                            Agent
                            </label>
                        </div>
                        <div className='col-sm-6'>
                            <Select
                                onBlur={() => {
                                    handleBlur({ target: { name: "staff_id" } });
                                }}
                                name='staff_id'
                                ref={agentCusRef}
                                data={
                                    values.office_id === 1 || values.office_id === '1'
                                    ? unpaginated_users?.map((item) => ({
                                        label: item?.last_name + " " + item?.first_name,
                                        value: item?.id,
                                        }))
                                    : sortedUsers
                                }
                                value={parseInt(values?.staff_id)}
                                onChange={(selectedOption) => {
                                    setFieldValue("staff_id", selectedOption?.value);
                                    setFieldError("staff_id", "");
                                }}
                            />
                        </div>
                    </div>
                    {/* <div className='row mt-2'>
                        <div className='col-lg-2 col-md-3 text-end sm-text-end'>
                            <label htmlFor='account_type' className={`form-label mt-1`}>
                            Action
                            </label>
                        </div>
                        <div className='col-sm-6'>
                            <Select
                                onBlur={() => {
                                    handleBlur({ target: { name: "action" } });
                                }}
                                name='action'
                                ref={actionCusRef}
                                data={actions?.map((item, i) => ({
                                    label: item?.Action,
                                    value: item?.Action,
                                }))}
                                value={values?.action}
                                onChange={(selectedOption) => {
                                    setFieldValue("action", selectedOption?.value);
                                    setFieldError("action", "");
                                }}
                            />
                        </div>
                    </div> */}
                    <div className='row mt-2'>
                        <div className='col-lg-2 col-md-3 text-end sm-text-end'>
                            <label htmlFor='account_type' className={`form-label mt-1`}>
                            Start Date<span className='text-danger'>*</span>
                            </label>
                        </div>
                        <div className='col-sm-6'>
                            <input
                            type='date'
                            id='start_date'
                            name='start_date'
                            className={`form-control form-control-sm`}
                            value={values?.start_date}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />
                            {errors?.start_date && touched?.start_date && (
                                <p className='mb-0 text-danger'>
                                    {errors?.start_date + "*"}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className='row mt-2'>
                        <div className='col-lg-2 col-md-3 text-end sm-text-end'>
                            <label htmlFor='account_type' className={`form-label mt-1`}>
                            End Date<span className='text-danger'>*</span>
                            </label>
                        </div>
                        <div className='col-sm-6'>
                            <input
                            type='date'
                            id='end_date'
                            name='end_date'
                            className={`form-control form-control-sm`}
                            value={values?.end_date}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            />     
                            {errors?.end_date && touched?.end_date && (
                                <p className='mb-0 text-danger'>
                                    {errors?.end_date + "*"}
                                </p>
                            )}                      
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-lg-2 col-md-3"></div>
                        <div className="col-sm-6">
                            <div className='d-flex align-items-center gap-2 mt-2'>
                                <button type='submit' className='btn btn-sm btn-primary '>
                                    Generate Report
                                </button>
                                {filteredItem ? (
                                    <button
                                    type='button'
                                    className='btn btn-sm btn-secondary'
                                    onClick={clearFilteredItems}
                                    >
                                    Clear Filter
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            {userActivity && <div className="row mb-3">
            <>
                {/* <div className='d-flex justify-content-end align-items-center'>
                    <div className=' d-flex align-items-center border '>
                    <span
                        className='bg-info me-2 text-white'
                        style={{ padding: "3px" }}
                    >
                        Export to
                    </span>

                    <span
                        href='#'
                        id='btnExport'
                        className='me-1 cursor-p'
                        title='Export to Pdf'
                        onClick={generatePDF}
                    >
                        <img
                        src={pdf}
                        alt='export-pdf'
                        style={{ height: "25px" }}
                        />
                    </span>
                    {currentUserActivities ? (
                        <CSVLink
                        data={exportXlsxData(
                            currentUserActivities,
                            "All User Activities"
                        )}
                        style={{ fontWeight: "bolder", cursor: "pointer" }}
                        filename='Corperate customers'
                        >
                        <span
                            href='#'
                            id='btnExport'
                            className='mr-1'
                            title='Export to Excel'
                        >
                            <img
                            src={excel}
                            alt='export-excel'
                            style={{ height: "25px", marginRight: "5px" }}
                            />
                        </span>
                        </CSVLink>
                    ) : null}
                    </div>
                </div> */}
                <div className='table-responsive'>
                    <table className='table table-centered table-striped nowrap w-100 no-footer' ref={CCPdfRef}>
                        <thead>
                            <tr>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "100.8px" }}
                                    aria-label='Email: activate to sort column ascending'
                                >
                                    Action
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "150.8px" }}
                                    aria-label='Customer: activate to sort column ascending'
                                >
                                    Entity
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                    Performed At
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "144.8px" }}
                                    aria-label='Phone: activate to sort column ascending'
                                >
                                    Performed By
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "156.8px" }}
                                    aria-label='Location: activate to sort column ascending'
                                >
                                    Approved By
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                Approved On
                                </th>
                                <th
                                    className='sorting'
                                    tabIndex='0'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "120.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                >
                                Branch
                                </th>
                                <th style={{ width: "105.8px" }}>Action</th>
                            </tr>
                        </thead>
                        {userActivity?.data?.length ? <tbody>
                            {userActivity?.data?.map((item, i) => ( 
                                <tr key={i}>
                                    <td className='text-dark'>
                                        {item?.Action}
                                    </td>
                                    <td className='table-user'>
                                        <span
                                            className='text-body fw-semibold'
                                        >
                                            {item?.Entity}
                                        </span>
                                    </td>                                      
                                    <td className='table-user'>
                                        <span
                                            className='text-body fw-semibold'
                                        >
                                            {item?.PerformedAt}
                                        </span>
                                    </td>                                      
                                    <td>{item?.createdBy}</td>
                                    <td>{item?.approved_by || 'Nil'}</td>
                                    <td>{item?.approved_on || 'Nil'}</td>
                                    <td>{item?.office_name}</td>
                                    <td data-bs-toggle='modal' data-bs-target='#property_view' onClick={() => setProperties(item?.properties)}>
                                        <i className='mdi mdi-eye text-primary fs-4 mx-2'></i>
                                    </td>
                                </tr>
                            ))}
                        </tbody> : null}
                    </table>
                    {userActivity?.data?.length < 1 ? (
                        <h5 className='alert alert-info'>No result found!</h5>
                    ) : null}
                </div>
                {userActivity?.data?.length > 0 && <div className='row mt-2'>
                    <div className='col-sm-12 col-md-6'>
                        <div
                        className='dataTables_info table-pages'
                        id='products-datatable_info'
                        role='status'
                        aria-live='polite'
                        >
                        Showing users {userActivity?.from} to{" "}
                        {userActivity?.to} of {userActivity?.total}
                        </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                        <PaginationLinks
                            paginationData={userActivity}
                            getNextPage={fetchActivityHandler}
                        />
                    </div>
                </div>}
            </>
            </div>}
            {(isLoading) && (
                <div
                className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                style={{ height: "100%" }}
                >
                <div className='mx-auto'>
                    <BounceLoader
                    color='#090b8f'
                    loading={true}
                    // cssOverride={override}
                    size={50}
                    aria-label='Loading Spinner'
                    data-testid='loader'
                    className='ms-3'
                    />
                    <span className='fw-bolder text-primary-1 ms-2'>
                    Generating Report...
                    </span>
                </div>
                </div>
            )}
        </div>
        <ModalContainer
          modal_id='property_view'
          modal_width='modal-md'
          bradius='rounded-2'
        >
          <AuditProperties properties={properties} />
        </ModalContainer>
    </>
  )
}

export default AuditReport